module.exports = __webpack_public_path__ + "img/64_16.30ee0700.png";